export default __webpack_public_path__ + "static/media/video-1.cdf72d60.mp4";